import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[iccNumberInput]',
    standalone: false
})
export class NumberInputDirective {
    @Input() iccNumberInputInteger = false;

    constructor(private hostElement: ElementRef<HTMLInputElement>) {}

    @HostListener('keypress', ['$event'])
    onKeypress(event: KeyboardEvent): void {
        const charCode = event.which ? event.which : event.keyCode;
        const allowDecimalSeparator = !this.iccNumberInputInteger && (charCode === 46 || charCode === 44);

        if (charCode > 31 && (charCode < 48 || charCode > 57) && !allowDecimalSeparator) {
            event.preventDefault();
        }

        const currentValue = (event.target as HTMLInputElement).value;
        if (allowDecimalSeparator && (currentValue.includes('.') || currentValue.includes(','))) {
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent): void {
        event.preventDefault();
        const paste = event.clipboardData?.getData('text') || '';

        const pattern = this.iccNumberInputInteger ? /^[0-9]*$/ : /^[0-9]*[.,]?[0-9]*$/;
        if (pattern.test(paste)) {
            const input = event.target as HTMLInputElement;
            const normalizedValue = this.iccNumberInputInteger ? paste : paste.replace(',', '.');
            input.value = normalizedValue;
            input.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }

    @HostListener('blur')
    onBlur(): void {
        const input = this.hostElement.nativeElement;
        const normalizedValue = input.value.replace(/^(-?)0+(?=\d)/, '$1');

        if (normalizedValue !== input.value) {
            input.value = normalizedValue;
            input.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }
}
